import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../_services/alert.service';
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiIntegration } from '../../_services/api.integration';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-update-order-status',
  templateUrl: './update-order-status.component.html',
  styleUrls: ['./update-order-status.component.scss'],
})
export class UpdateOrderStatusComponent implements OnInit {

  orderNumber: string;
  statusText1: string = "";
  trackingOrderList: any = {};
  trackingOrder: any;

  constructor(public g: Globals, public user: User, private http: HttpClient, private api: ApiIntegration, private alertService: AlertService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() { }

  orderNumberBlur() {
    this.statusText1 = "";
    if (this.orderNumber == '' || this.orderNumber === null || this.orderNumber === undefined || this.orderNumber === 'undefined') {
      this.statusText1 = 'Please enter Order Number';
    }
  }

  submit() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.g.loaderDisplay = "";
    this.http.get(environment.apiUrl + 'api/trackOrderForShipment?orderNumber=' + this.orderNumber,
      { headers: header1 }).subscribe((data: any) => {
        if (data['code'] == 200) {
          this.trackingOrderList = data;
          this.trackingOrder = this.trackingOrderList.trackingOrderList;
          this.alertService.success('Status Updated Successfully');
          this.router.navigate(['admin/adminShipmentList']);
        }
        else {
          this.alertService.error('Error', data['Failed to update status']);
        }
      },
        err => {
          console.log(err);
        });
  }


}
